module.exports = __webpack_public_path__ + "img/notary-journal_B09KDYTYZY.e8da084c.jpg";